var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorporationActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 14.708,
    viewBox: "0 0 22 14.708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4357",
    "data-name": "Group 4357",
    transform: "translate(6097.907 8928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-pax",
    transform: "translate(-6090.615 -8928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-or",
    d: "M0,14.708H5.447L4.4,9.261A23.485,23.485,0,0,0,.516,11.7,1.345,1.345,0,0,0,0,12.759v1.948Zm6.421,0H8.282l-.423-2.794.547-.873-.819-1,2.18-1.513V7.56a3.085,3.085,0,0,0,.414-1.08c.2-.014.4-.345.59-.985.153-.52.164-.872.033-1.047a.322.322,0,0,0-.275-.124l-.053,0a2.712,2.712,0,0,0,.119-.432,2.939,2.939,0,0,0,0-1.37,2.957,2.957,0,0,0-.832-1.4A3.988,3.988,0,0,0,8.991.51,3.054,3.054,0,0,0,8.242.141,2.555,2.555,0,0,0,7.567.016,2.908,2.908,0,0,0,5.859.362a2.09,2.09,0,0,0-.832.743.988.988,0,0,0-.638.391,2.993,2.993,0,0,0-.276,2.4,2.691,2.691,0,0,0,.119.432h0l-.05,0a.323.323,0,0,0-.275.124c-.131.175-.119.527.034,1.047.184.636.382.968.589.985a3.033,3.033,0,0,0,.414,1.08v.992l2.18,1.513-.819,1,.552.849-.432,2.793Zm2.839,0h5.447V12.769a1.344,1.344,0,0,0-.517-1.071H14.2A23.557,23.557,0,0,0,10.3,9.261L9.261,14.707Z",
    transform: "translate(0 0)",
    fill: "#04be76"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon-pax-2",
    "data-name": "icon-pax",
    transform: "translate(-6097.907 -8923.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-or-2",
    "data-name": "icon-or",
    d: "M0,10.028H3.714L3,6.314A16.013,16.013,0,0,0,.352,7.977.917.917,0,0,0,0,8.7v1.328Zm4.378,0H5.647l-.288-1.9.373-.6-.558-.682L6.66,5.815v-.66a2.1,2.1,0,0,0,.282-.736c.138-.009.273-.236.4-.672.1-.354.112-.595.023-.714a.22.22,0,0,0-.187-.085l-.036,0a1.849,1.849,0,0,0,.081-.295,2,2,0,0,0,0-.934A2.016,2.016,0,0,0,6.657.765,2.719,2.719,0,0,0,6.13.348,2.082,2.082,0,0,0,5.619.1a1.742,1.742,0,0,0-.46-.086A1.983,1.983,0,0,0,3.995.247a1.425,1.425,0,0,0-.568.507.674.674,0,0,0-.435.267A2.041,2.041,0,0,0,2.8,2.655a1.835,1.835,0,0,0,.081.295H2.849a.22.22,0,0,0-.187.084c-.089.119-.081.359.023.714.125.434.26.66.4.672a2.068,2.068,0,0,0,.282.736v.676L4.855,6.862,4.3,7.544l.376.579-.295,1.9Zm1.936,0h3.714V8.706a.916.916,0,0,0-.352-.73h0A16.061,16.061,0,0,0,7.025,6.314l-.711,3.714Z",
    transform: "translate(0 0)",
    fill: "#04be76"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporationActive);
export default __webpack_public_path__ + "static/media/corporation_active.2d67a2934816c0d0d21f7e4bee74b8d1.svg";
export { ForwardRef as ReactComponent };